import { IPostingTranslationQuery } from '../interfaces/interfaces/posting-translation.query.interface';

export class PostingTranslation {
    id: string;
    language: string;
    title: string;
    description: string;

    constructor(postingTranslationQuery?: IPostingTranslationQuery) {
        if (postingTranslationQuery) {
            if (postingTranslationQuery.id) {
                this.id = postingTranslationQuery.id.toString();
            }
            this.language = postingTranslationQuery.language;
            this.title = postingTranslationQuery.title;
            this.description = postingTranslationQuery.description;
        }
    }
}
